import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: theme.spacing(60),
    margin: 'auto',
  },
  title: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(5),
  },
}));
export const CreditsPage = (): JSX.Element => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h5" component="div" className={classes.title}>
        Credits
      </Typography>
      <Typography>
        FlashyPlayer uses, for both its website and software, icons from{' '}
        <a href="https://icons8.com/" target="_blank" rel="noopener noreferrer">
          icons8.com
        </a>
        .
      </Typography>
      <Typography>
        FlashyPlayer uses, for its website, videos from{' '}
        <a
          href="https://www.vidsplay.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          vidsplay.com
        </a>
        .
      </Typography>
    </div>
  );
};
